import { Directive, HostListener, ElementRef, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

const ALLOWED_CONTROL_KEYS = new Set([
  'Backspace', 'Tab', 'Delete', 'Enter', 'Escape',
  'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
  'Home', 'End',
]);

@Directive({
  selector: '[appDigitOnly]',
  standalone: true,
})
export class DigitOnlyDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Optional() private ngControl: NgControl,
  ) {}

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (event.ctrlKey || event.metaKey) return;
    if (ALLOWED_CONTROL_KEYS.has(event.key)) return;
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pasted = event.clipboardData?.getData('text') ?? '';
    const digitsOnly = pasted.replace(/\D/g, '');
    const input = this.el.nativeElement;
    const start = input.selectionStart ?? input.value.length;
    const end = input.selectionEnd ?? input.value.length;
    const newValue = input.value.slice(0, start) + digitsOnly + input.value.slice(end);
    input.value = newValue;
    if (this.ngControl?.control) {
      this.ngControl.control.setValue(newValue);
    } else {
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    const caret = start + digitsOnly.length;
    input.setSelectionRange(caret, caret);
  }
}
